var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name === _vm.currentKey && _vm.asc)?_c('i',{staticClass:"fas fa-sort-up"}):(_vm.name === _vm.currentKey)?_c('i',{staticClass:"fas fa-sort-down"}):_c('i',{staticClass:"fas fa-sort text-secondary"})
}
var staticRenderFns = []

export { render, staticRenderFns }